import { APIClient } from "../helpers/api_helper";
import { getMfaSessionToken } from "../helpers/mfaSession_helper";

const api = new APIClient();

const mfaAuthConfig = (mfaSessionToken) => ({
  headers: {
    Authorization: `Bearer ${mfaSessionToken}`,
  },
});

/**
 * Step 1 — validate email + password only.
 * Returns mfaSessionToken + nextStep (MFA_SETUP | MFA_VERIFY). Does NOT return full admin token.
 */
export const adminLogin = async (credentials) => {
  try {
    return await api.create("/auth/admin/login/v2", {
      email: credentials.email,
      password: credentials.password,
    });
  } catch (error) {
    throw error;
  }
};

/**
 * Step 2A — get QR/secret for first-time MFA setup.
 * Requires Authorization: Bearer <mfaSessionToken>
 */
export const adminMfaSetup = async (mfaSessionToken) => {
  const token = mfaSessionToken || getMfaSessionToken();
  if (!token) {
    const err = new Error("Session expired, login again");
    err.status = 401;
    throw err;
  }
  try {
    return await api.create("/auth/admin/mfa/setup", {}, mfaAuthConfig(token));
  } catch (error) {
    throw error;
  }
};

/**
 * Step 2A — enable MFA with first TOTP code; returns FULL login tokens.
 */
export const adminMfaEnable = async (mfaCode, mfaSessionToken) => {
  const token = mfaSessionToken || getMfaSessionToken();
  if (!token) {
    const err = new Error("Session expired, login again");
    err.status = 401;
    throw err;
  }
  try {
    return await api.create(
      "/auth/admin/mfa/enable",
      { mfaCode },
      mfaAuthConfig(token)
    );
  } catch (error) {
    throw error;
  }
};

/**
 * Step 2B — verify TOTP for MFA-enabled admin; returns FULL login tokens.
 */
export const adminMfaVerify = async (mfaCode, mfaSessionToken) => {
  const token = mfaSessionToken || getMfaSessionToken();
  if (!token) {
    const err = new Error("Session expired, login again");
    err.status = 401;
    throw err;
  }
  try {
    return await api.create(
      "/auth/admin/mfa/verify",
      { mfaCode },
      mfaAuthConfig(token)
    );
  } catch (error) {
    throw error;
  }
};

/**
 * Refresh Token
 */
export const refreshToken = async (refreshToken) => {
  try {
    return await api.create("/auth/refresh", {
      refreshToken: refreshToken,
    });
  } catch (error) {
    throw error;
  }
};

/**
 * Logout
 */
export const logout = async () => {
  try {
    return await api.create("/auth/logout", {});
  } catch (error) {
    throw error;
  }
};
